import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "redux/types";
import { Response } from "services/types";
import { OrderQuote } from "services/order/types";
import { OrderService } from "services/order/order.service";
import { AddQuoteRequest, DeleteQuotesRequest, EditQuoteRequest, GetQuotesRequest } from "./types";

/**
 * Load Quote by executing a remote API call.
 */
export const loadQuotes = createAsyncThunk<Response<OrderQuote[]>, GetQuotesRequest, ThunkApiConfig>(
  "quotes/load",
  async (request, thunkAPI) => {
    const service = new OrderService();
    const response = await service.getOrders();

    return response;
  }
);

/**
 * Load Quote by executing a remote API call.
 */
export const deleteQuotes = createAsyncThunk<Response<number[]>, DeleteQuotesRequest, ThunkApiConfig>(
  "quotes/delete",
  async (request, thunkAPI) => {
    const service = new OrderService();
    const response = await service.deleteQuotes({ ids: request.ids });
    const result: Response<number[]> = { ...response, data: request.ids };

    return result;
  }
);

/**
* Add Quote by executing a remote API call.
*/
export const addQuote = createAsyncThunk<Response<OrderQuote>, AddQuoteRequest, ThunkApiConfig>(
  "quotes/add",
  async (request, thunkAPI) => {
    const service = new OrderService();
    const response = await service.addQuote(request.quote);

    return response;
  }
);

/**
* Edit Quote by executing a remote API call.
*/
export const editQuote = createAsyncThunk<Response<OrderQuote>, EditQuoteRequest, ThunkApiConfig>(
  "quotes/edit",
  async (request, thunkAPI) => {
    const service = new OrderService();
    const response = await service.editQuote(request.quote);

    return response;
  }
);
